module.exports = __webpack_public_path__ + "img/CM-SL-24-Nissan-Established.5fe55189.jpg";